import styled from 'styled-components';
export const ProgressBarContainer = styled.div`
  width: 100%;
  height: ${_ref => {
  let {
    size
  } = _ref;
  return size === 'sm' ? '2px' : '4px';
}};
  background-color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme?.colors?.secondaryL1;
}};
`;
export const FilledBar = styled.div`
  width: ${_ref3 => {
  let {
    value,
    max
  } = _ref3;
  return value / max * 100;
}}%;
  height: 100%;
  background-color: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme?.colors?.primary;
}};
  transition: width 0.5s ease-in-out;
`;